exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../../../../assets/img/success_smile.svg"));

// Module
exports.push([module.id, ".root_12UcHgrQU9 {\n  width: 328px;\n}\n.formControls_UoB1ONqIeP {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.result_2IndSnM8fT {\n  text-align: center;\n}\n.result_2IndSnM8fT .resultIcon_3Vzq-SxqzM {\n  width: 64px;\n  height: 64px;\n  background-size: contain;\n  background: url(" + ___CSS_LOADER_URL___0___ + ") no-repeat center;\n  margin: 0 auto 16px auto;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "root_12UcHgrQU9",
	"formControls": "formControls_UoB1ONqIeP",
	"result": "result_2IndSnM8fT",
	"resultIcon": "resultIcon_3Vzq-SxqzM"
};